import styled from '@emotion/styled'
import { Button, Flex } from '@collable/ui'
import { useNavigate } from 'react-router-dom'

interface AuthLayoutProps {
  children: React.ReactNode
  headerButton: 'back' | 'cancle'
}

const AuthLayout = ({ children, headerButton }: AuthLayoutProps) => {
  const navigate = useNavigate()
  return (
    <Container>
      <Layout direction="column" alignItems="center" gap={40} as="main">
        <Header alignItems="center" as="header">
          {headerButton === 'back' && (
            <Button
              kind="outline"
              color="neutral"
              variant="leftIcon"
              size="small"
              iconProps={{ name: 'arrowChevronM', direction: 'left' }}
              onClick={() => navigate(-1)}
            >
              돌아가기
            </Button>
          )}
          {headerButton === 'cancle' && (
            <CancelButton
              kind="solid"
              color="neutral"
              variant="rightIcon"
              size="small"
              iconProps={{ name: 'xSm' }}
              onClick={() => navigate('/')}
            >
              회원가입 취소하기
            </CancelButton>
          )}
        </Header>
        {children}
      </Layout>
    </Container>
  )
}

export default AuthLayout

const Container = styled.div`
  background-color: ${({ theme }) => theme.background.backgroundAlternative};
`

const Layout = styled(Flex)`
  max-width: 1440px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0 48px 40px 48px;
`

const Header = styled(Flex)`
  width: 100%;
  padding: 0 48px;
  height: 80px;
`

const CancelButton = styled(Button)`
  margin-left: auto;
`
